interface JsonEditorProps {
  value: string;
  onChange: (value: string) => void;
  onValidate: () => void;
}

export function JsonEditor({ value, onChange, onValidate }: JsonEditorProps) {
  const validateJsonLocally = () => {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  };

  const hasValidJson = validateJsonLocally();

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-semibold text-gray-900 dark:text-white">
          Request JSON
        </label>
        <span
          className={`text-xs font-medium px-2 py-1 rounded ${
            hasValidJson
              ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200'
              : 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200'
          }`}
        >
          {hasValidJson ? '✅ Valid JSON' : '❌ Invalid JSON'}
        </span>
      </div>

      <div className="relative">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full h-96 p-4 font-mono text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 resize-none focus:outline-none focus:ring-2 transition-colors ${
            hasValidJson
              ? 'border-gray-300 dark:border-gray-600 focus:ring-green-500'
              : 'border-red-300 dark:border-red-600 focus:ring-red-500'
          }`}
          spellCheck={false}
          aria-label="Request JSON editor"
        />
      </div>

      <button
        onClick={onValidate}
        className="px-4 py-2 bg-gray-600 hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 text-white rounded-lg transition-colors text-sm font-medium"
      >
        🔍 Validate JSON
      </button>

      {!hasValidJson && (
        <div className="px-4 py-3 bg-red-50 dark:bg-red-900 dark:bg-opacity-30 border border-red-200 dark:border-red-700 rounded-lg text-sm text-red-800 dark:text-red-300">
          <p className="font-medium mb-1">Invalid JSON</p>
          <p className="text-xs">Check the syntax and try again. Watch for missing commas and quotes.</p>
        </div>
      )}

      {hasValidJson && (
        <div className="px-4 py-3 bg-green-50 dark:bg-green-900 dark:bg-opacity-30 border border-green-200 dark:border-green-700 rounded-lg text-sm text-green-800 dark:text-green-300">
          <p className="text-xs">✓ JSON is valid and ready to submit</p>
        </div>
      )}
    </div>
  );
}
